import * as React from 'react';
import * as _ from 'lodash';
import SearchBar from '../../components/SearchBar';
import { cleanProps } from '../../utilities/props';
import { GlobalHeaderButtons } from '../../components/PageLayout/GlobalHeaderButtons';
export default function (props, context) {
    function onChange1(e) {
        props.setSearchTerm(e.target.value);
    }
    return React.createElement('div', _.assign({}, cleanProps(props)), React.createElement(GlobalHeaderButtons, {}), React.createElement('div', { 'className': 'lightbox-header-container' }, React.createElement('div', { 'className': 'lightbox-title-block' }, React.createElement('h1', { 'id': 'PageTitle' }, 'Installation Options Setup'), React.createElement('p', {}, 'Select the installation groups are available for quoting.'))), React.createElement(SearchBar, {
        'value': props.term,
        'componentClassName': 'app-search--with-desc',
        'onChange': onChange1.bind(this)
    }), React.createElement('div', {}));
}